var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "addProds",
        "body-class": "px-0 py-0",
        "ok-only": true,
        "ok-title": "Подтвердить"
      },
      on: { hidden: _vm.modalClosed }
    },
    [
      _vm.product && _vm.allDops
        ? [
            _c(
              "b-card",
              [
                _c("template", { slot: "header" }, [
                  _c("b", [_vm._v("Добавленные допы:")])
                ]),
                _vm._v(" "),
                _c(
                  "b-card-group",
                  {
                    staticClass: "grid grid-3 products pb-1",
                    attrs: { id: "dop-added" }
                  },
                  _vm._l(_vm.addedAdditionalProducts, function(prod) {
                    return _c(
                      "b-card",
                      {
                        key: prod.index,
                        staticClass: "text-center my-1 prod prod-added",
                        attrs: { "no-body": "" },
                        on: {
                          click: function($event) {
                            _vm.product.groupProds.splice(
                              _vm.product.groupProds.indexOf(prod),
                              1
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "px-1 py-1 d-flex flex-column h-100 justify-content-center",
                            attrs: { id: "prod" + prod.id }
                          },
                          [
                            _c("div", [_vm._v(_vm._s(prod.name))]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sub-info" }, [
                              _vm._v(_vm._s(prod.cost) + " ₽")
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "b-card",
              [
                _c("template", { slot: "header" }, [
                  _c("b", [_vm._v("Все допы:")])
                ]),
                _vm._v(" "),
                _c(
                  "b-card-group",
                  {
                    staticClass: "grid grid-3 products  pb-1",
                    attrs: { id: "dop-all" }
                  },
                  _vm._l(
                    _vm.allDops.get(
                      _vm.product.prod
                        ? _vm.product.prod.idCategory
                        : _vm.product.idCategory
                    ),
                    function(prod) {
                      return _c(
                        "b-card",
                        {
                          key: prod.id,
                          staticClass: "text-center my-1 prod",
                          attrs: { "no-body": "" },
                          on: {
                            click: function($event) {
                              return _vm.addAdditionalProduct(prod)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "px-1 py-1 d-flex flex-column h-100 justify-content-center",
                              attrs: { id: "prod" + prod.id }
                            },
                            [
                              _c("div", [_vm._v(_vm._s(prod.name))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "sub-info" }, [
                                _vm._v(_vm._s(prod.cost) + " ₽")
                              ])
                            ]
                          )
                        ]
                      )
                    }
                  ),
                  1
                )
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad42cc9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad42cc9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddAdditionalProducts.vue
// module id = null
// module chunks = 